import { FormEvent } from "react"
import FormInput from "../../../../../../components/FormInput/FormInput"
import { WorkflowInfoFormProps } from "./WorkflowInfoForm.type"
import FormDropdown from "../../../../../../components/FormDropdown/FormDropdown"
import "./WorkflowInfoForm.css"

const WorkflowInfoForm = (props: WorkflowInfoFormProps) => {

  const { 
    pipeId,
    location,
    pipeLength,
    pipeTemperature,
    pipeDiameter,
    assetType,
    workflowStart,
    workflowEnd,
    insulationMaterial,
    insulationThickness,
    claddingMaterial,
    claddingThickness,
    hasTracingCable,
    onSubmit
  } = props

  const submitWorkflow = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <form className="workflow-form-container" onSubmit={submitWorkflow}>
      <div className="pipe-info-form-container">
        <h3>Pipe information</h3>
        <div className="pipe-info-form">
          <FormInput 
            className="pipe-id-input"
            label={"Pipe ID"}
            input={pipeId}
          />

          <FormDropdown
            label="Location"
            dropdown={location}
          />

          <FormInput 
            label={"Pipe Length"}
            input={pipeLength}
          />

          <FormInput 
            label={"Pipe Temperature"}
            input={pipeTemperature}
          />

          <FormInput 
            label={"Pipe Diameter"}
            input={pipeDiameter}
          />

          <FormDropdown 
            label={"Asset Type"}
            dropdown={assetType}
          />

          <FormInput 
            label={"Workflow Start"}
            input={workflowStart}
          />

          <FormInput 
            label={"Workflow End"}
            input={workflowEnd}
          />

          <FormDropdown
            label={"Tracing cable"} 
            dropdown={hasTracingCable}
          />
       </div>
      </div>

      <div className="insulation-cladding-form-container">
        <div className="pipe-info-form-container">
          <h3>Insulation information</h3>

          <div className="insulation-cladding-form">
            <FormDropdown 
              label={"Insulation Material"}
              dropdown={insulationMaterial}
            />

            <FormInput 
              label={"Insulation Thickness"}
              input={insulationThickness}
            />
          </div>
        </div>

        <div className="pipe-info-form-container">
          <h3>Cladding information</h3>
          <div className="insulation-cladding-form">
            <FormDropdown
              label={"Cladding Material"}
              dropdown={claddingMaterial}
            />

            <FormInput 
              label={"Cladding Thickness"}
              input={claddingThickness}
            />
          </div>
        </div>
      </div>
    </form>
  )
}

export default WorkflowInfoForm